// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:23:56

export default {
  "id": "chill-girl-clicker",
  "slug": "chill-girl-clicker",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8490f0000f9240ab82c96d3e1d91267a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8490f0000f9240ab82c96d3e1d91267a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Chill Girl Clicker",
      "description": "Chill Girl Clicker is a soothing, laid-back clicker game that’s perfect for unwinding and finding your zen. Just like its predecessor, Chill Girl Clicker, this game offers a serene and calming experience, but with a delightful twist: a charming girl as the main character, bringing a fresh and enchanting vibe to your screen.",
      "instructions": "Click to play!",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "clicker",
        "idle",
        "relaxing"
      ]
    },
    "zh-CN": {
      "title": "冷静女孩点击器",
      "description": "冷静女孩点击器是一款舒缓、轻松的点击游戏，非常适合放松身心，寻找内心的宁静。正如其前身冷静女孩点击器一样，这款游戏提供了一种宁静和放松的体验，但加入了令人愉悦的转折：一位迷人的女孩成为主角，为你的屏幕带来清新而迷人的氛围。",
      "instructions": "点击开始游戏！",
      "genres": [
        "模拟"
      ],
      "tags": [
        "点击器",
        "休闲",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "冷靜女孩點擊器",
      "description": "Chill Girl Clicker 是一款舒緩、悠閒的點擊遊戲，完美適合放鬆身心，尋找你的寧靜。就像它的前身 Chill Girl Clicker 一樣，這款遊戲提供一個寧靜與寧靜的體驗，但帶來一個令人愉悅的變化：一個可愛的女孩作為主角，為你的螢幕帶來新鮮迷人的氣息。",
      "instructions": "點擊開始遊戲！",
      "genres": [
        "模擬"
      ],
      "tags": [
        "點擊器",
        "閒置",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "冷靜女孩點擊器",
      "description": "Chill Girl Clicker是一款舒緩、寧靜的點擊遊戲，完美適合放鬆心情，尋找你的禪境。就像其前作Chill Girl Clicker一樣，這款遊戲提供了一個寧靜安心的體驗，但帶來了一個令人歡喜的轉變：一個可愛的女孩作為主角，為你的螢幕帶來一種新鮮迷人的氣息。",
      "instructions": "點擊遊玩！",
      "genres": [
        "模擬"
      ],
      "tags": [
        "點擊器",
        "閒置",
        "放鬆"
      ]
    },
    "ja": {
      "title": "クールガールクリッカーレス",
      "description": "Chill Girl Clickerは、リラックスして禅を感じるのに最適な穏やかでリラックスしたクリッカーゲームです。その前作、Chill Girl Clickerと同様に、このゲームも静謐で落ち着いた体験を提供しますが、魅力的なツイストがあります：主役は魅力的な少女で、スクリーンに新鮮で魔法のような雰囲気をもたらします。",
      "instructions": "ゲームを始めるにはクリックしてください！",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "クリッカーゲーム",
        "インディーゲーム",
        "リラックスゲーム"
      ]
    },
    "ko": {
      "title": "침정 소녀 클릭러",
      "description": "Chill Girl Clicker는 편안하고 쉬운 클릭러 게임으로, 휴식을 취하고 자신의 존재감을 찾는 데 완벽합니다. 이전 작품인 Chill Girl Clicker와 마찬가지로, 이 게임은 평화로운 안정된 경험을 제공하지만, 기쁜 돌발적인 요소로 주인공으로서 매력적인 소녀가 등장하여 화면에 새로운 매력적인 분위기를 불러옵니다.",
      "instructions": "게임을 시작하려면 클릭하세요!",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "클릭러",
        "아이드ل",
        "쉬운"
      ]
    },
    "fr": {
      "title": "Fille Calme Clic",
      "description": "Chill Girl Clicker est un jeu de clic apaisant et décontracté parfait pour se détendre et trouver son zen. Comme son prédécesseur, Chill Girl Clicker, ce jeu propose une expérience sereine et apaisante, mais avec une touche delightfully originale : une charmante jeune fille en tant que personnage principal, apportant une ambiance fraîche et enchantante à votre écran.",
      "instructions": "Cliquez pour jouer !",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "cliqueur",
        "idle",
        "apaisant"
      ]
    }
  }
};
